import { GroupContractStepIdentifier } from '../types/enums';

export const ADMIN_PROCESS_PREFIX = '/back-office/contrats-groupe/process';
export const BROKER_PROCESS_PREFIX = '/mes-contrats-collectifs/process';

const STEP_TO_PATH: Record<GroupContractStepIdentifier, string> = {
  [GroupContractStepIdentifier.Subscriber]: 'souscripteur',
  [GroupContractStepIdentifier.Products]: 'produits',
  [GroupContractStepIdentifier.Brokers]: 'courtiers',
  [GroupContractStepIdentifier.Contractualization]: 'contractualisation',
  [GroupContractStepIdentifier.Active]: 'contractualisation',
};

const STEP_TO_TRANSLATION_KEY: Record<GroupContractStepIdentifier, string> = {
  [GroupContractStepIdentifier.Subscriber]: 'GROUP_CONTRACT_PROCESS.STEPS.SUBSCRIBER',
  [GroupContractStepIdentifier.Products]: 'GROUP_CONTRACT_PROCESS.STEPS.PRODUCTS',
  [GroupContractStepIdentifier.Brokers]: 'GROUP_CONTRACT_PROCESS.STEPS.BROKERS',
  [GroupContractStepIdentifier.Contractualization]: 'GROUP_CONTRACT_PROCESS.STEPS.CONTRACTUALIZATION',
  [GroupContractStepIdentifier.Active]: 'GROUP_CONTRACT_PROCESS.STEPS.ACTIVE',
};

export const getRoutePathForStep = (step: GroupContractStepIdentifier): string => STEP_TO_PATH[step];

export const getTranslationKeyForStep = (step: GroupContractStepIdentifier): string =>
  STEP_TO_TRANSLATION_KEY[step];

/**
 * Detects the process route prefix from the current pathname.
 * Falls back to the admin prefix.
 */
export const detectProcessPrefix = (pathname: string): string =>
  pathname.includes(BROKER_PROCESS_PREFIX) ? BROKER_PROCESS_PREFIX : ADMIN_PROCESS_PREFIX;

export const buildProcessRoute = (
  groupContractId: string,
  step: GroupContractStepIdentifier,
  prefix: string = ADMIN_PROCESS_PREFIX,
): string => `${prefix}/${groupContractId}/${getRoutePathForStep(step)}`;
